import gsap from 'gsap';

import VoteModal from './modal/main';
import VoteList from './votelist/main';


export default class Main{
    
    constructor(){
        this._init();
    }


    _init(){
        const votelist = new VoteList();
        const vmodal = new VoteModal();
    }
}